module.exports = __webpack_public_path__ + "img/lg_ring_g_e_null_null@3x.2472bbd9.png";